import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowDownToLine } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export default function WalletWithdraw() {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);
  const [can, setCan] = useState(null);
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api("/withdrawals/config").then(setConfig).catch(() => setConfig({}));
    api("/withdrawals/can-request").then(setCan).catch(() => setCan({ can_request: true }));
  }, []);

  const request = async () => {
    if (!amount) return toast.error("أدخل المبلغ");
    setBusy(true);
    try { await api("/withdrawals/request", { method: "POST", body: JSON.stringify({ amount: Number(amount) }) }); toast.success("تم إرسال طلب السحب"); setAmount(""); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const hasBank = user?.bank_account_holder && user?.bank_name && user?.bank_account_number;

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="سحب رصيد" subtitle={`رصيدك: ${Number(user?.wallet_balance || 0).toFixed(2)} د.ل`} backTo="/wallet" />
      {config && <p className="text-sm text-[#6B7280] mb-3">الحد الأدنى للسحب: {config.min_amount ?? 50} د.ل • فترة الانتظار: {config.cooldown_days ?? 7} يوم</p>}
      {!hasBank && <div className="p-4 rounded-2xl bg-[#FFF7E0] border border-[#FFB627] text-[#B07700] text-sm font-bold mb-3">يجب إكمال بيانات الحساب البنكي في تعديل الملف الشخصي قبل السحب.</div>}
      {can && can.can_request === false && <div className="p-4 rounded-2xl bg-[#FFE5EA] text-[#FF3D5A] text-sm font-bold mb-3">{can.reason || "لا يمكنك تقديم طلب سحب حالياً"}</div>}
      <p className="text-sm font-bold mb-1.5">المبلغ (د.ل)</p>
      <input data-testid="withdraw-amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="w-full bg-white rounded-xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
      <button data-testid="withdraw-submit" disabled={busy || !hasBank} onClick={request} className="w-full flex items-center justify-center gap-2 h-13 py-4 rounded-2xl bg-[#FF3D5A] text-white font-black mt-5 disabled:opacity-60"><ArrowDownToLine size={18} /> {busy ? "..." : "طلب السحب"}</button>
    </div>
  );
}
